module.exports = __webpack_public_path__ + "static/img/211_TO8_2149.45f213e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/211_TO8_2149.jpg
// module id = FF3J
// module chunks = 0